import { createContext } from 'react';
import { Article, Category } from '../backend/models';
import { TreelizedCategory } from '../utils/treelizeCategories';

export const KbContext = createContext<{
    allCategories: Array<Category>,
    allArticles: Array<Article>,
    treelizedCategories: Array<TreelizedCategory>
} | null>(null);